import { QA_DEEP_DIVES } from "@/data/qa/authored-deep-dives";

export function QaDeepDive({ path }: { path: string }) {
  const d = QA_DEEP_DIVES[path];
  if (!d) return null;
  return (
    <div className="mb-8 space-y-6">
      <figure>
        <img src={d.image.src} alt={d.image.alt} width={d.image.width} height={d.image.height} loading="lazy" className="w-full rounded-lg object-cover" />
        <figcaption className="mt-2 text-xs text-muted-foreground">{d.image.alt}</figcaption>
      </figure>
      {d.sections.map((s) => (
        <section key={s.h}>
          <h2 className="mb-2 text-xl font-semibold">{s.h}</h2>
          {s.p.map((p, i) => <p key={i} className="mb-3 leading-relaxed">{p}</p>)}
        </section>
      ))}
      {d.steps && (
        <section>
          <h2 className="mb-2 text-xl font-semibold">ขั้นตอนที่ทำได้ทันที</h2>
          <ol className="list-decimal space-y-1 pl-5">{d.steps.map((s) => <li key={s}>{s}</li>)}</ol>
        </section>
      )}
      <section className="rounded-lg border border-border bg-muted p-4">
        <h2 className="mb-2 text-lg font-semibold">ข้อควรระวัง</h2>
        <ul className="list-disc space-y-1 pl-5 text-sm">{d.cautions.map((c) => <li key={c}>{c}</li>)}</ul>
      </section>
      <section>
        <h2 className="mb-2 text-lg font-semibold">แหล่งอ้างอิง</h2>
        <ul className="list-disc space-y-1 pl-5 text-sm">
          {d.sources.map((s) => <li key={s.label}><a href={s.url} target="_blank" rel="noopener noreferrer" className="text-primary underline">{s.label}</a></li>)}
        </ul>
        <p className="mt-2 text-xs text-muted-foreground">เรียบเรียงและตรวจทานเมื่อ {d.reviewedTh}</p>
      </section>
    </div>
  );
}
